export const requestWaitingTime = 5000;
/**
 * RSM_KEY - ключ квери параметра, значение которого при равенстве 1 обозначает, что
 * в квери параметрах может быть информация о кампании, по ссылке которой пользователь пришёл к нам
 */
export const RSM_KEY = 'rsm';
/**
 * MT_LINK_ID_KEY - ключ квери параметра, в значении которого находится айди кампании, по
 * ссылке которой пришёл пользователь
 */
export const MT_LINK_ID_KEY = 'mt_link_id';

export const MT_CREATIVE = 'mt_creative';

export const DEFAULT_PAGE_SIZE = 20;

export const LOGO_WALL_LINE_COUNT = 7;

export const PREV_SCREEN_INDEX = 2;
export const CURRENT_SCREEN_INDEX = 1;

export const NEXT_STEP_INDEX = 2;

export const EVEN_NUMBER_DELIMITER = 2;
export const THREE_COUNT = 3;
export const LAST_TWO_ITEMS_COUNT = -2;

export const FIRST_FIVE_ITEMS = -5;

export const MOBILE_SCREEN_WIDTH = 720;
export const TABLET_SCREEN_WIDTH = 1023;

export const ENTER_BUTTON_KEY_CODE = 13;

export const COPY_BUTTON_SHOW_TIME = 3000;

export const FAILED_AUTH_INDEX = -1;

export const AUTHORS_PAGE_SIZE = 20;
